export default function PageHeader({ label, children }) {
  return (
    <div className="flex items-center justify-between mb-6" data-testid="page-header">
      <div className="section-label flex-1">
        <span>{label}</span>
        <span className="flex-1 h-px bg-[#1E2D45]" />
      </div>
      {children && <div className="flex items-center gap-3 ml-4">{children}</div>}
    </div>
  );
}
